import React, { useEffect, useState } from 'react';
import { Chart } from 'primereact/chart';

const SalesProfitChart = (props) => {
    const [salesProfitChartData, setSalesProfitChartData] = useState({});
    const [salesProfitChartOptions, setSalesProfitChartOptions] = useState({});
    const {last6MonthSalesProfitData } = props


    useEffect(() => {
        const labels = last6MonthSalesProfitData?.map(item => {
            const month = item.reportingMonth?.split(' ')[0];
            return month;
        });
        const salesData = last6MonthSalesProfitData?.map(item => parseFloat(item?.monthlySales));
        const profitData = last6MonthSalesProfitData?.map(item => parseFloat(item?.monthlyProfit));
    
        const data = {
            labels: labels,
            datasets: [
                {
                    label: 'Sales',
                    type: 'bar',
                    data: salesData,
                    yAxisID: 'y',
                    backgroundColor: 'rgba(54, 162, 235, 0.6)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    borderWidth: 1,
                },
                {
                    label: 'Profit (%)',
                    type: 'line',
                    data: profitData,
                    yAxisID: 'y1',
                    fill: false,
                    borderColor: 'rgba(255, 99, 132, 1)',
                    borderWidth: 1,
                },
            ],
        };
    
        const options = {
            scales: {
                y: {
                    title: {
                        display: true,
                        text: 'Sales',
                        font: {
                            size: 14,
                            weight: 'bold',
                        },
                    },
                    type: 'linear',
                    display: true,
                    position: 'left',
                    id: 'y-axis-1',
                    scaleLabel: {
                        display: true,
                        labelString: 'Sales',
                    },
                    ticks: {
                        beginAtZero: true
                    },
                },
                y1: {
                    title: {
                        display: true,
                        text: 'Profit (%)',
                        font: {
                            size: 14,
                            weight: 'bold',
                        },
                    },
                    type: 'linear',
                    display: true,
                    position: 'right',
                    id: 'y-axis-2',
                    scaleLabel: {
                        display: true,
                        labelString: 'Profit (%)',
                    },
                    ticks: {
                        beginAtZero: false
                    },
                },
            },
        };
    
        setSalesProfitChartData(data);
        setSalesProfitChartOptions(options);
    }, [last6MonthSalesProfitData]);
    

    return (
        <div>
            <Chart type="bar" data={salesProfitChartData} options={salesProfitChartOptions} style={{ height: "400px", width: ""}} />
        </div>
    );
};

export default SalesProfitChart;
